// extracted by mini-css-extract-plugin
module.exports = {"loader-wrapper":"loader_loader-wrapper___EGNg","loader":"loader_loader__31U88","spin":"loader_spin__3GevV"};